module.exports = __webpack_public_path__ + "static/img/img_form_1@2x_ja.5b95fdc8.png";